import React from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AdminDashboard() {
  return (
    <AdminLayout>
      <div className="p-6 text-white">
        <h1 className="text-3xl font-bold mb-2">
          Welcome Mr. MOKU, <span className="text-yellow-400">President of WAR FC</span>
        </h1>
        <p className="text-gray-400 mb-6">God-mode control panel</p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          
          {/* TOURNAMENTS */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-gray-900 p-5 rounded-xl border border-gray-700 shadow"
          >
            <h2 className="text-xl font-bold">Tournaments</h2>
            <p className="text-gray-400">Brackets & competition formats</p>
            <div className="mt-3 flex gap-2">
              <Link to="/admin/tournament/create" className="btn btn-primary">
                Create
              </Link>
              <Link to="/admin/tournaments" className="btn">
                Manage
              </Link>
            </div>
          </motion.div>

          {/* EVENTS (NEW) */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-gray-900 p-5 rounded-xl border border-gray-700 shadow"
          >
            <h2 className="text-xl font-bold">Events</h2>
            <p className="text-gray-400">Fight nights & fight cards</p>
            <div className="mt-3 flex gap-2">
              <Link to="/admin/events/create" className="btn btn-primary">
                Create
              </Link>
              <Link to="/admin/events/create" className="btn">
                Manage
              </Link>
            </div>
          </motion.div>

{/* HOMEPAGE COVER */}
<motion.div
  whileHover={{ scale: 1.03 }}
  className="bg-gray-900 p-5 rounded-xl border border-gray-700 shadow"
>
  <h2 className="text-xl font-bold">
    Homepage Cover
  </h2>

  <p className="text-gray-400">
    Change the main homepage cover image
  </p>

  <div className="mt-3">
    <Link
      to="/admin/home-cover"
      className="btn btn-primary"
    >
      Manage
    </Link>
  </div>
</motion.div>

          {/* JUDGES */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-gray-900 p-5 rounded-xl border border-gray-700"
          >
            <h2 className="text-xl font-bold">Judges</h2>
            <p className="text-gray-400">Assign judges to events</p>
            <div className="mt-3">
              <Link to="/admin/judges" className="btn">
                Manage
              </Link>
            </div>
          </motion.div>

        </div>
      </div>
    </AdminLayout>
  );
}
